import { createStore } from 'devextreme-aspnet-data-nojquery';
import sharedApi from '../SharedApi';
import userApi from '../UserApi';

// The log is far too large to hold client-side, so the grid's filtering, sorting and paging are
// sent to the endpoint and applied in the database by DataSourceLoader.
export const auditEntriesStore = () => createStore({
    key: 'id',
    loadUrl: sharedApi.generateURL('api/audit/entries'),
    onBeforeSend: (method: string, ajaxOptions: any) => {
        ajaxOptions.xhrFields = { withCredentials: true };
        ajaxOptions.headers = { 'Authorization': 'Bearer ' + userApi.getAccessToken() };
    }
});
